import { useCallback, useEffect, useState } from 'react';

export const useDropzone = (allowDrop: boolean, isDragging: boolean) => {
  const [targetted, setTargetted] = useState(false);

  const handleDragLeave = useCallback(() => {
    if (allowDrop) {
      setTargetted(false);
    }
  }, [allowDrop]);

  const handleDragOver = useCallback(
    (event: React.DragEvent) => {
      if (allowDrop) {
        event.preventDefault();
        setTargetted(true);
      }
    },
    [allowDrop]
  );

  useEffect(() => {
    if (!isDragging) {
      setTargetted(false);
    }
  }, [isDragging]);

  return {
    handleDragLeave,
    handleDragOver,
    targetted
  };
};
